'use client'

import { Line } from '../../icons'
import { Container, Text } from './styles'

export interface LineButtonProps {
  /**
   * Click handler
   */
  onClick?: () => void

  /**
   * Button label
   */
  children?: React.ReactNode
}

export const LineButton = ({ onClick, children }: LineButtonProps) => {
  return (
    <Container onClick={onClick}>
      <Line />
      <Text>{children}</Text>
    </Container>
  )
}
